export default "__VITE_ASSET__BsJOZeB4__"